import produce from 'immer';
import { createModel, RematchDispatch } from '@rematch/core';

import { RootModel } from '../models';
import { UserType } from '../../types/user.type';
import * as AuthService from '../../services/auth';

export const storeName = 'userModel';

type UserModelTypes = {
  user: UserType;
};

const initialState: UserModelTypes = {
  user: undefined,
};

export const userModel: any = createModel<RootModel>()({
  name: storeName,
  state: initialState,
  reducers: {
    setUser: produce((state, payload: boolean) => {
      state.user = payload;
    }),
  },
  effects: (dispatch: RematchDispatch) => ({
    async getUserDetailAsync() {
      return AuthService.getUserDetail().then((res: any) => {
        const { data } = res;
        data.permissions = data.roles.flatMap((r: any) => r.permissions).map((p: any) => p.name);
        this.setUser(data);
        return data;
      });
    },
  }),
});

export default userModel;
